import React, { useState } from "react";
import Logo from "../assets/img/logo.png";
import { axiosReq } from "../assets/commons/axiosReq";
import ClipLoader from "react-spinners/ClipLoader"
import parse from 'html-react-parser';


const RecommenderPage = () => {
  const [selectedOption, setSelectedOption] = useState(null);
  const [submittedMessage, setSubmittedMessage] = useState("");
  const [message, setMessage] = useState();
  const [salary, setSalary] = useState();
  const [has_supporter, setHas_supporter] = useState(false);
  const [get_salary_bank, setSalary_bank] = useState(false);
  const [account_duration, setAccount_duration] = useState();
  const [account_type, setAccount_type] = useState();
  const [snipper, setSnipper] = useState(false);


  const handleOptionSelect = (option) => {
    setSelectedOption(option);
    setSubmittedMessage("");
  };

  const handleSubmit = async () => {
    setSnipper(true)
    var mes;
    console.log(5545)
    console.log(salary)
    const dataFile = await axiosReq(selectedOption == "account" ? "recommend/account" :
      selectedOption == "deposit" ? "recommend/deposit" :
        selectedOption == "loan" ? "recommend/loan" :
          "", "post", {
      salary: parseInt(salary),
      has_supporter: has_supporter == "true" ? true : false,
      get_salary_bank: get_salary_bank == "true" ? true : false,
      account_duration: parseInt(account_duration),
      account_type: account_type
    });
    if (dataFile?.status == 200 || dataFile?.status == 204 || dataFile?.status == 201) {
      // const pieces = dataFile?.data?.split('/')
      // props.setFiles(true)
      console.log(123)
      console.log(dataFile.data)
      mes = dataFile.data;
      setMessage(dataFile.data);
      setSnipper(false)
    }
    else {
      console.log(dataFile)
      setSnipper(false)

      alert("ارتباط برقرار نشد ");
    }
    switch (selectedOption) {
      case "account":
        setSubmittedMessage("پیشنهاد سیستم توصیه گر برای افتتاح حساب به شما :" + mes);
        break;
      case "deposit":
        setSubmittedMessage("پیشنهاد سیستم توصیه گر به شما برای سپرده :" + mes);
        break;
      case "loan":
        setSubmittedMessage("پیشنهاد سیستم توصیه گر به شما برای وام :" + mes);
        break;
      default:
        setSubmittedMessage("");
    }
  };

  return (
    <>
      <div className="h-screen flex flex-col justify-center items-center bg-gray-100 hasBackgroud">
        <div className="bg-white w-[70%] lg:w-[95%] max-w-[500px] rounded-xl p-6 shadow-lg flex flex-col items-start relative">
          <img src={Logo} className="w-[80px] mb-4 mx-auto block" alt="logo" />
          <h2 className="text-[18px] text-[#f4752a] font-IRANYekanExtra mb-2 text-center mx-auto">
            به دستیار هوشمند بانک سپه خوش آمدید!
          </h2>
          <h2 className="text-[14px] font-IRANYekanExtra text-[#000] text-center mx-auto">
            در چه زمینه ای نیاز به استفاده از سیستم توصیه‌گر را دارید؟
          </h2>

          {selectedOption === null ? (
            <div className="my-4 flex items-center w-full">
              <button
                onClick={() => handleOptionSelect("account")}
                className="flex justify-center bg-[#fff] mx-1 w-full text-[14px] font-IRANYekanBold text-[#f4752a] shadow-dropbox-shadow px-2 py-2 rounded-lg mt-4 hover:bg-[#000]"
              >
                <span className="mr-2">پیشنهاد حساب</span>
              </button>
              <button
                onClick={() => handleOptionSelect("deposit")}
                className="flex justify-center bg-[#f4752a] mx-1 w-full text-[14px] font-IRANYekanBold text-white px-2 py-2 rounded-lg mt-4 hover:bg-[#000]"
              >
                <span className="mr-2">پیشنهاد سپرده</span>
              </button>
              <button
                onClick={() => handleOptionSelect("loan")}
                className="flex justify-center bg-[#fff] mx-1 w-full text-[14px] font-IRANYekanBold text-[#f4752a] shadow-dropbox-shadow px-2 py-2 rounded-lg mt-4 hover:bg-[#000]"
              >
                <span className="mr-2">پیشنهاد وام</span>
              </button>
            </div>
          ) : null}


          {selectedOption === "account" && (
            <div className="w-full mt-4">
              <input
                type="text"
                name="salary1"
                placeholder="میزان حقوق"
                className="border my-2  p-2 rounded-lg w-full text-right font-IRANYekanMedium inputF border-[#c7c7c7]"
                onChange={(e) => setSalary(e.target.value)}
              />
              <button
                onClick={() => handleSubmit()}
                className="w-full px-3  font-IRANYekanExtra py-2 bg-[#f4752a] text-white rounded-lg"
              >
{
                                snipper ?
                                    <ClipLoader
                                        color={"#000"}
                                        loading={snipper}
                                        size={20}
                                        aria-label={"loading spinner"}
                                        data-testid="loader"

                                    />
                                    :
                                    <p>ثبت</p>}              </button>
            </div>
          )}


          {selectedOption === "deposit" && (
            <div className="w-full mt-4">
              {/* <input
                type="text"
                placeholder="ضامن"
                onClick={(e)=>setHas_supporter(true)}
                className="border my-2  p-2 rounded-lg w-full text-right font-IRANYekanMedium inputF border-[#c7c7c7]"
                   
              /> */}
              <div className="col-span-2 mb-[10px] flex flex-col  mt-4">

                <p className="text-[15px] font-IRANYekanBold text-mainColor2 mb-2">
                  ضامن
                </p>
                <label className="flex items-center">
                  <input
                    type="radio"
                    name="has_supporter"
                    value={true}
                    checked={has_supporter === "true"}
                    onChange={(e) => setHas_supporter(e.target.value)}
                    className="w-4 h-4 text-Orange2 border-gray-300 focus:ring-Orange2 ml-2"
                  />
                  <span className="ml-2 text-[14px] font-IRANYekanNormal">دارد</span>
                </label>
                <label className="flex items-center">
                  <input
                    type="radio"
                    name="has_supporter"
                    value={false}
                    checked={has_supporter === "false"}
                    onChange={(e) => setHas_supporter(e.target.value)}
                    className="w-4 h-4 text-Orange2 border-gray-300 focus:ring-Orange2 ml-2"
                  />
                  <span className="ml-2 text-[14px] font-IRANYekanNormal">ندارد</span>
                </label>
              </div>
              {/* <input
                type="text"
                placeholder="دریافت حقوق از بانک"
                className="border my-2  p-2 rounded-lg w-full text-right font-IRANYekanMedium inputF border-[#c7c7c7]"
                onClick={(e)=>setSalary_bank(true)}
              /> */}
              <div className="col-span-2 mb-[10px] flex flex-col  mt-4">

                <p className="text-[15px] font-IRANYekanBold text-mainColor2 mb-2">
                  دریافت حقوق از بانک
                </p>
                <label className="flex items-center">
                  <input
                    type="radio"
                    name="get_salary_bank"
                    value={true}
                    checked={get_salary_bank === "true"}
                    onChange={(e) => setSalary_bank(e.target.value)}
                    className="w-4 h-4 text-Orange2 border-gray-300 focus:ring-Orange2 ml-2"
                  />
                  <span className="ml-2 text-[14px] font-IRANYekanNormal">دارد</span>
                </label>
                <label className="flex items-center">
                  <input
                    type="radio"
                    name="get_salary_bank"
                    value={false}
                    checked={get_salary_bank === "false"}
                    onChange={(e) => setSalary_bank(e.target.value)}
                    className="w-4 h-4 text-Orange2 border-gray-300 focus:ring-Orange2 ml-2"
                  />
                  <span className="ml-2 text-[14px] font-IRANYekanNormal">ندارد</span>
                </label>
              </div>
              <input
                type="number"
                placeholder="مدت زمان حساب"
                className="border my-2  p-2 rounded-lg w-full text-right font-IRANYekanMedium inputF border-[#c7c7c7]"
                onChange={(e) => setAccount_duration(e.target.value)}
              />
              <button
                onClick={() => handleSubmit()}
                className="w-full px-3  font-IRANYekanExtra py-2 bg-[#f4752a] text-white rounded-lg"
              >
              {
                                snipper ?
                                    <ClipLoader
                                        color={"#000"}
                                        loading={snipper}
                                        size={20}
                                        aria-label={"loading spinner"}
                                        data-testid="loader"

                                    />
                                    :
                                    <p>ثبت</p>}
              </button>
            </div>
          )}


          {selectedOption === "loan" && (
            <div className="w-full mt-4">
              <input
                type="number"
                name="salary"
                placeholder="میزان حقوق"
                className="border my-2  p-2 rounded-lg w-full text-right font-IRANYekanMedium inputF border-[#c7c7c7]"
                onChange={(e) => setSalary(e.target.value)}
              />

              <div className="col-span-2 mb-[10px] flex flex-col  mt-4">

                <p className="text-[15px] font-IRANYekanBold text-mainColor2 mb-2">
                  ضامن
                </p>
                <label className="flex items-center">
                  <input
                    type="radio"
                    name="has_supporter"
                    value={true}
                    checked={has_supporter === "true"}
                    onChange={(e) => setHas_supporter(e.target.value)}
                    className="w-4 h-4 text-Orange2 border-gray-300 focus:ring-Orange2 ml-2"
                  />
                  <span className="ml-2 text-[14px] font-IRANYekanNormal">دارد</span>
                </label>
                <label className="flex items-center">
                  <input
                    type="radio"
                    name="has_supporter"
                    value={false}
                    checked={has_supporter === "false"}
                    onChange={(e) => setHas_supporter(e.target.value)}
                    className="w-4 h-4 text-Orange2 border-gray-300 focus:ring-Orange2 ml-2"
                  />
                  <span className="ml-2 text-[14px] font-IRANYekanNormal">ندارد</span>
                </label>
              </div>
              {/* <input
                type="text"
                placeholder="نوع حساب"
                className="border my-2  p-2 rounded-lg w-full text-right font-IRANYekanMedium inputF border-[#c7c7c7]"
                onClick={(e)=>setAccount_type(true)}

              /> */}
                <div className="col-span-2 mb-[10px] flex flex-col  mt-4">

<p className="text-[15px] font-IRANYekanBold text-mainColor2 mb-2">
دریافت حقوق از بانک
                 </p>
 <label className="flex items-center">
                         <input
                             type="radio"
                             name="get_salary_bank"
                             value={true}
                             checked={get_salary_bank === "true"}
                             onChange={(e)=>setSalary_bank(e.target.value)}
                             className="w-4 h-4 text-Orange2 border-gray-300 focus:ring-Orange2 ml-2"
                         />
                         <span className="ml-2 text-[14px] font-IRANYekanNormal">دارد</span>
                     </label>
                     <label className="flex items-center">
                         <input
                             type="radio"
                             name="get_salary_bank"
                             value={false}
                             checked={get_salary_bank === "false"}
                             onChange={(e)=>setSalary_bank(e.target.value)}
                             className="w-4 h-4 text-Orange2 border-gray-300 focus:ring-Orange2 ml-2"
                         />
                         <span className="ml-2 text-[14px] font-IRANYekanNormal">ندارد</span>
                     </label>
                     </div>
              <select
                className="border p-2 rounded-lg w-full text-right font-IRANYekanMedium inputF border-[#c7c7c7]"
                value={account_type}
                onChange={(e) => setAccount_type(e.target.value)}
              >
                <option value="">انتخاب کنید</option>
                <option value="حساب قرض الحسنه جاری">حساب قرض الحسنه جاری</option>
                <option value="حساب قرض الحسنه پس انداز">حساب قرض الحسنه پس انداز</option>
                <option value="حساب جاری">حساب جاری</option>
                <option value="جساب کوتاه مدت عادی">جساب کوتاه مدت عادی</option>
                <option value="حساب های ارزی">حساب های ارزی</option>
              </select>
              <input
                type="number"
                placeholder="مدت زمان حساب"
                className="border my-2  p-2 rounded-lg w-full text-right font-IRANYekanMedium inputF border-[#c7c7c7]"
                onChange={(e) => setAccount_duration(e.target.value)}
              />
              <button
                onClick={() => handleSubmit()}
                className="w-full  font-IRANYekanExtra px-3 py-2 bg-[#f4752a] text-white rounded-lg"
              >
                 {
                                snipper ?
                                    <ClipLoader
                                        color={"#000"}
                                        loading={snipper}
                                        size={20}
                                        aria-label={"loading spinner"}
                                        data-testid="loader"

                                    />
                                    :
                                    <p>ثبت</p>}
              </button>
            </div>
          )}


          {submittedMessage && (
            <div className="mt-4 text-center text-[#f4752a]">
              <p className="font-IRANYekanMedium ">{  parse(submittedMessage)}</p>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default RecommenderPage;
